var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import pick from 'lodash.pick';
import { useSelector } from 'react-redux';
import { createSlice, } from '@reduxjs/toolkit';
/**
 * 创建 Redux 状态模型
 */
export function createModel(_a) {
    var name = _a.name, initialState = _a.initialState, reducers = _a.reducers;
    var slice = createSlice({
        name: name,
        initialState: initialState,
        reducers: __assign(__assign({}, reducers), { 
            /**
             * 修改指定（一级）字段的状态值
             */
            change: {
                reducer: function (state, _a) {
                    var payload = _a.payload;
                    return __assign(__assign({}, state), payload);
                },
                prepare: function (payload) {
                    return { payload: payload };
                },
            }, 
            /**
             * 以 merge 的方式修改指定字段的状态值，最多支持二级
             */
            merge: {
                reducer: function (state, _a) {
                    var payload = _a.payload;
                    var mergedState = Object.keys(payload).reduce(function (ret, key) {
                        if (Array.isArray(payload[key])) {
                            ret[key] = payload[key];
                        }
                        else if (typeof payload[key] === 'object' && payload[key]) {
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            ret[key] = __assign(__assign({}, (state[key] || {})), payload[key]);
                        }
                        else {
                            ret[key] = payload[key];
                        }
                        return ret;
                    }, {});
                    return __assign(__assign({}, state), mergedState);
                },
                prepare: function (payload) {
                    return { payload: payload };
                },
            }, 
            /**
             * 重置所有（或部分）字段的状态到初始值
             */
            reset: {
                reducer: function (state, _a) {
                    var payload = _a.payload;
                    return __assign(__assign({}, state), ((payload === null || payload === void 0 ? void 0 : payload.keys) ? pick(initialState, payload.keys) : initialState));
                },
                prepare: function (payload) {
                    return { payload: payload };
                },
            } }),
    });
    /**
     * 获取 Model 状态
     * @param rootStateGetter 获取根状态的方法，通常是 `store.getState`
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function selectState(rootStateGetter) {
        return (rootStateGetter()[name] || {});
    }
    /**
     * 获取 Model 状态 (React Hooks 版本)
     */
    function useState() {
        return useSelector(function (state) { return state[name]; });
    }
    return __assign(__assign({}, slice), { selectState: selectState, useState: useState });
}
